import { defineStore } from 'pinia';
import { ref } from 'vue';

export type ConnectionState = 'online' | 'reconnecting';

export const useConnectionStore = defineStore('connection', () => {
  const state = ref<ConnectionState>('online');
  const activeReconnects = ref(0);

  function syncState(): void {
    const next = activeReconnects.value > 0 ? 'reconnecting' : 'online';
    if (state.value !== next) {
      state.value = next;
    }
  }

  function setReconnecting(): void {
    activeReconnects.value += 1;
    syncState();
  }

  function setOnline(): void {
    activeReconnects.value = Math.max(0, activeReconnects.value - 1);
    syncState();
  }

  return { state, setReconnecting, setOnline };
});
